<template>
  <canvas ref="chart"></canvas>
</template>

<script>
import { Chart } from "chart.js";

export default {
  name: "MrrLineChart",
  props: {
    chartData: {
      type: Object,
      default: () => ({ labels: [], values: [] }),
    },
    color: {
      type: String,
      default: "#2e4664",
    },
    label: {
      type: String,
      default: "MRR",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(value);
    },
    renderChart() {
      if (!this.chartData || !this.chartData.labels || !this.chartData.values) return;

      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.chart.getContext("2d");
      const self = this;

      const datalabelsPlugin = {
        id: 'mrrDatalabels',
        afterDatasetsDraw(chart) {
          const { ctx } = chart;
          chart.data.datasets.forEach((dataset, datasetIndex) => {
            const meta = chart.getDatasetMeta(datasetIndex);
            meta.data.forEach((point, index) => {
              const value = dataset.data[index];
              if (value === 0 || value === null || value === undefined) return;
              ctx.save();
              ctx.fillStyle = dataset.borderColor || '#2e4664';
              ctx.font = 'bold 10px sans-serif';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
              ctx.fillText(self.formatCurrency(value), point.x, point.y - 8);
              ctx.restore();
            });
          });
        },
      };

      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.chartData.labels,
          datasets: [
            {
              label: this.label,
              data: this.chartData.values,
              borderColor: this.color,
              backgroundColor: this.color + "33",
              tension: 0.3,
              fill: true,
              pointRadius: 4,
              pointHoverRadius: 6,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 25,
            },
          },
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  return self.label + ": " + self.formatCurrency(context.raw);
                },
              },
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              beginAtZero: true,
              ticks: {
                callback: (value) => self.formatCurrency(value),
              },
            },
          },
        },
        plugins: [datalabelsPlugin],
      });
    },
  },
};
</script>
